var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 79,
    viewBox: "0 0 85 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 69.125H14.1667C13.2274 69.125 12.3265 68.7782 11.6623 68.1609C10.9981 67.5436 10.625 66.7063 10.625 65.8333V41.8042C10.6251 41.3354 10.7329 40.8721 10.9411 40.4452C11.1494 40.0184 11.4534 39.6377 11.8327 39.3288L17.7083 34.5625V13.1667C17.7083 12.2937 18.0815 11.4564 18.7457 10.8391C19.4099 10.2218 20.3107 9.875 21.25 9.875H70.8333C71.7726 9.875 72.6735 10.2218 73.3377 10.8391C74.0019 11.4564 74.375 12.2937 74.375 13.1667V65.8333C74.375 66.7063 74.0019 67.5436 73.3377 68.1609C72.6735 68.7782 71.7726 69.125 70.8333 69.125ZM31.875 24.1246C32.7325 24.1256 33.5606 24.4156 34.2054 24.941L51.9137 39.342C52.2919 39.6491 52.5955 40.0275 52.8043 40.452C53.0132 40.8765 53.1225 41.3374 53.125 41.8042V62.5417H67.2917V16.4583H24.7917V28.8021L29.541 24.9377C30.1873 24.4128 31.0167 24.1238 31.875 24.1246ZM28.3333 52.6667H35.4167V62.5417H46.0417V43.3085L31.875 31.7876L17.7083 43.3085V62.5417H28.3333V52.6667Z",
    fill: "#FF9A02"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.28d813a4a2a82f0e9bfc610d1b6f73d6.svg";
export { ForwardRef as ReactComponent };